import { Alert } from '@zillow/constellation-10';
import type { AlertRootPropsInterface } from '@zillow/constellation-10';
import type { SatelliteWebLandlordLeadManagementTableRowAlertDto } from '@zg-rentals/ts-satellite-client';

type RenterDetailsAlertsProps = {
  alerts: Array<SatelliteWebLandlordLeadManagementTableRowAlertDto> | undefined;
};

export default function RenterDetailsAlerts({ alerts }: RenterDetailsAlertsProps) {
  if (!alerts?.length) return null;

  return (
    <>
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          css={{ marginTop: 'loose' }}
          tone={alert.tone.toLowerCase() as AlertRootPropsInterface['tone']}
        >
          {alert.text}
        </Alert>
      ))}
    </>
  );
}
